export default __webpack_public_path__ + "static/media/BurgerLogger.9c3ed7bf.jpg";